<script setup lang="ts">
const props = defineProps<{
  open?: boolean
}>()

const emit = defineEmits(['hide'])
</script>

<template>
  <div
    class=" row-start-1 row-end-1 col-start-1 col-end-1 px-2xl xl:py-15 flex flex-col gap-12 transform-gpu duration-400 ease-in-out z-80 overflow-y-auto"
    :class="props.open ? 'translate-y-0 bg-background-1 max-h-[calc(100svh-72px)] xl:max-h-none pointer-events-auto' : '-translate-y-full pointer-events-none'"
  >
    <NuxtLink
      to="/sprzedaz-mieszkan/"
      class="py-2.5 px-3 border-b border-Tertiary w-fit"
      @click="emit('hide')"
    >
      <span class="text-H4 font-semibold! text-Tekst">Sprzedaż mieszkań</span>
    </NuxtLink>
    <div
      class="flex flex-col xl:flex-row xl:gap-20 justify-between"
      @click="emit('hide')"
    >
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/sprzedaz-mieszkan/#dlaczego-warto"
          class="w-full"
        >
          <span class="text-Menu">Dlaczego warto zamieszkać w Ostoi Seniora</span>
        </AppButton2>
        <AppButton2
          href="/sprzedaz-mieszkan/#dodatkowe-uslugi"
          class="w-full"
        >
          <span class="text-Menu">Dodatkowe usługi</span>
        </AppButton2>
        <AppButton2
          href="/sprzedaz-mieszkan/#plan-inwestycji"
          class="w-full"
        >
          <span class="text-Menu">Plan inwestycji</span>
        </AppButton2>
        <AppButton2
          href="/sprzedaz-mieszkan/#wyszukaj-mieszkanie"
          class="w-full"
        >
          <span class="text-Menu">Wyszukaj mieszkanie</span>
        </AppButton2>
      </div>
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/sprzedaz-mieszkan/#czesci-wspolne"
          class="w-full"
        >
          <span class="text-Menu">Części wspólne</span>
        </AppButton2>
        <AppButton2
          href="/sprzedaz-mieszkan/#jedzenie"
          class="w-full"
        >
          <span class="text-Menu">Jedzenie</span>
        </AppButton2>
        <AppButton2
          href="/sprzedaz-mieszkan/#aktywnosci-i-zycie-spoleczne"
          class="w-full"
        >
          <span class="text-Menu">Aktywności i życie społeczne</span>
        </AppButton2>
        <AppButton2
          href="/sprzedaz-mieszkan/#galeria"
          class="w-full"
        >
          <span class="text-Menu">Galeria</span>
        </AppButton2>
      </div>
      <div class="flex flex-col flex-1">
        <AppButton2
          href="/sprzedaz-mieszkan/#lokalizacja"
          class="w-full"
        >
          <span class="text-Menu">Lokalizacja</span>
        </AppButton2>
        <AppButton2
          href="/sprzedaz-mieszkan/#kontakt"
          class="w-full"
        >
          <span class="text-Menu">Kontakt</span>
        </AppButton2>
      </div>
    </div>
  </div>
</template>
